import { render } from "./hanukaMaanit22.vue?vue&type=template&id=1fc28409&scoped=true"
import script from "./hanukaMaanit22.vue?vue&type=script&lang=js"
export * from "./hanukaMaanit22.vue?vue&type=script&lang=js"

import "./hanukaMaanit22.vue?vue&type=style&index=0&id=1fc28409&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc28409"]])

export default __exports__